<template>
  <main class="trial-page">
    <section class="visual-section hero">
      <img src="@/assets/trial/hero.jpg" alt="金箱智慧门店首年免费使用" />
    </section>

    <section class="visual-section capability-section">
      <img src="@/assets/trial/capabilities.jpg" alt="金箱智慧门店四大核心能力" />
    </section>

    <section class="apply-section">
      <div class="scan-title">欢迎扫码，即刻体验</div>
      <div class="qr-card"><img src="@/assets/trial/qrcode.jpg" alt="金箱科技体验二维码" /></div>
      <p class="consulting-title">留下您的信息，专属顾问1对1服务</p>

      <form class="trial-form" @submit.prevent="submitForm">
        <label class="form-field">
          <span class="field-icon person-icon"></span>
          <input v-model.trim="form.userName" type="text" maxlength="20" placeholder="请输入您的姓名" autocomplete="name" />
        </label>
        <label class="form-field">
          <span class="field-icon phone-icon"></span>
          <input v-model.trim="form.mobile" type="tel" inputmode="numeric" maxlength="11" placeholder="请输入您的手机号" autocomplete="tel" />
        </label>
        <button class="submit-button" :disabled="submitting" type="submit">{{ submitting ? "提交中..." : "提交" }}</button>
      </form>
      <p class="privacy"><span class="lock-icon"></span>信息仅用于顾问回访，严格保密</p>
    </section>

    <footer class="page-footer">
      <a class="phone-button" href="tel:4008608020">
        <img src="@/assets/trial/consult-phone.png" alt="立即咨询 400-860-8020" />
      </a>
      <p class="brand-slogan">
        <strong>金箱科技</strong><i></i><span>黄金珠宝产业数字化服务提供商</span>
      </p>
      <small>正金产业运营服务集团旗下品牌</small>
      <address><span class="location-icon"></span>总部地址:深圳市罗湖区特力珠宝大厦 13 楼</address>
    </footer>
  </main>
</template>

<script>
import { Toast } from "vant";
import { applyTrial } from "@/api/trial";

export default {
  name: "TrialLandingPage",
  data() {
    return {
      submitting: false,
      form: {
        userName: "",
        mobile: "",
      },
    };
  },
  methods: {
    async submitForm() {
      if (!this.form.userName) {
        Toast("请输入您的姓名");
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(this.form.mobile)) {
        Toast("请输入正确的手机号");
        return;
      }

      this.submitting = true;
      try {
        const response = await applyTrial({
          userName: this.form.userName,
          mobile: this.form.mobile,
          message: "",
        });
        const result = response.data || {};
        if (result.code && Number(result.code) !== 200) {
          Toast(result.msg || "提交失败，请稍后重试");
          return;
        }
        Toast.success({
          message: result.msg || "提交成功，顾问将尽快与您联系",
          className: "trial-success-toast",
        });
        this.form.userName = "";
        this.form.mobile = "";
      } catch (error) {
        Toast("网络异常，请稍后重试");
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.trial-page {
  min-height: 100vh;
  overflow: hidden;
  color: #122b61;
  background:
    radial-gradient(circle at 86% 12%, rgba(108, 201, 255, 0.32), transparent 22vw),
    linear-gradient(155deg, #fbfdff 0%, #e8f5ff 31%, #d9edff 68%, #f2f9ff 100%);
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}

.visual-section { margin: 0; padding: 0; line-height: 0; }
.visual-section img { display: block; width: 100%; height: auto; }

.apply-section { padding: 6vw 8vw 0 8vw; text-align: center; background: linear-gradient(145deg, rgba(255,255,255,.14), rgba(212,235,255,.6)); background-color: #eef6fe; }
.scan-title { display: flex; align-items: center; justify-content: center; gap: 2vw; color: #19396d; font-size: 4vw; font-weight: 600; }.scan-title::before, .scan-title::after { content: ""; width: 12vw; height: 1px; background: #287ef4; }
.qr-card { width: 31vw; height: 31vw; margin: 3vw auto 4vw; padding: 1.6vw; box-sizing: border-box; border: 1.3vw solid #0669e9; border-radius: 2.5vw; background: white; box-shadow: 0 .8vw 1.2vw rgba(17,92,198,.18); }.qr-card img { width: 100%; height: 100%; object-fit: contain; }
.consulting-title { margin: 0 0 4vw; color: #173e7d; font-size: 4vw; font-weight: 600; }.trial-form { display: grid; gap: 3vw; }.form-field { height: 12.5vw; display: flex; align-items: center; border: .4vw solid #4c93fa; border-radius: 2vw; background: rgba(255,255,255,.95); box-shadow: 0 .6vw 1.2vw rgba(27,100,197,.1); }.form-field input { width: 0; flex: 1; height: 100%; outline: 0; border: 0; background: transparent; color: #173e7d; font-size: 4vw; }.form-field input::placeholder { color: #85a8dc; }.field-icon { width: 12vw; height: 100%; position: relative; flex: 0 0 12vw; }.person-icon::before { content: ""; position: absolute; left: 4.4vw; top: 2.3vw; width: 3.1vw; height: 3.1vw; border: .45vw solid #6f9fe8; border-radius: 50%; }.person-icon::after { content: ""; position: absolute; left: 2.9vw; bottom: 2.2vw; width: 6vw; height: 3.7vw; border: .45vw solid #6f9fe8; border-bottom: 0; border-radius: 5vw 5vw 0 0; }.phone-icon::before { content: ""; position: absolute; left: 3.8vw; top: 2.1vw; width: 4.3vw; height: 7.4vw; border: .45vw solid #6f9fe8; border-radius: .5vw; }.phone-icon::after { content: ""; position: absolute; left: 5.3vw; bottom: 3vw; width: 1.5vw; height: .45vw; border-radius: 1vw; background: #6f9fe8; }
.submit-button { height: 12.5vw; margin-top: 1vw; border: 0; border-radius: 2vw; color: #fff; background: linear-gradient(100deg, #0566dd, #0754d8); box-shadow: 0 1vw 1vw rgba(3,76,191,.21); font-size: 4.8vw; font-weight: 700; }.submit-button:disabled { opacity: .65; }.privacy { display: flex; justify-content: center; align-items: center; margin: 2.7vw 0 0; color: #5377b4; font-size: 3.2vw; }.lock-icon { width: 3.4vw; height: 2.7vw; position: relative; display: inline-block; margin: 1.1vw 1vw 0 0; border: .4vw solid #5377b4; border-radius: .5vw; }.lock-icon::before { content: ""; position: absolute; left: .55vw; bottom: 2.4vw; width: 1.5vw; height: 1.5vw; border: .4vw solid #5377b4; border-bottom: 0; border-radius: 2vw 2vw 0 0; }

.page-footer { padding: 3vw 8vw calc(9vw + env(safe-area-inset-bottom)); text-align: center; background: linear-gradient(155deg, rgba(218,240,255,.45), rgba(183,222,255,.85)); background-color: #eef6fe; }.phone-button { display: block; line-height: 0; text-decoration: none; }.phone-button img { display: block; width: 100%; height: auto; }.brand-slogan { display: flex; align-items: center; justify-content: center; margin: 5vw 0 1.5vw; color: #233d75; font-size: 3.6vw; line-height: 1.25; white-space: nowrap; }.brand-slogan strong { font-size: 5vw; font-weight: 700; letter-spacing: .15vw; }.brand-slogan i { width: 1px; height: 4.7vw; margin: 0 1vw; background: #233d75; }.brand-slogan span { font-weight: 400; }.page-footer small { color: #6281b4; font-size: 3.3vw; }.page-footer address { display: flex; align-items: center; justify-content: center; margin-top: 4vw; color: #5d7daf; font-size: 3.2vw; font-style: normal; }.location-icon { width: 3.4vw; height: 3.4vw; position: relative; flex: 0 0 3.4vw; margin-right: 1.3vw; border: .45vw solid #5d7daf; border-radius: 50% 50% 50% 0; transform: rotate(-45deg); }.location-icon::after { content: ""; position: absolute; width: 1vw; height: 1vw; top: .75vw; left: .75vw; border-radius: 50%; background: #5d7daf; }
</style>

<style lang="less">
.trial-success-toast {
  width: 62vw;
  min-width: 62vw;
  max-width: 62vw;
  box-sizing: border-box;
}

.trial-success-toast .van-toast__text {
  white-space: normal;
  line-height: 1.45;
}
</style>
